module.exports = __webpack_public_path__ + "static/media/Zeitungsartikel_WP_2025-02-17.c6b3f721.jpg";